import { forwardRef, type Ref, type SVGProps } from "react";

function SvgShiftProtection(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} width={176} height={120} viewBox="0 0 315 358" fill="none" {...props}>
      <g clipPath="url(#clip0_11_29)">
        <path
          d="M244.565 75.3814C165.064 75.3814 129.517 34.2609 129.174 33.8589C127.11 31.3788 122.89 31.3788 120.826 33.8589C120.478 34.27 85.2972 75.3814 5.43498 75.3814C2.43432 75.3814 0 77.8158 0 80.8166V184.543C0 241.247 25.4896 295.134 68.1839 328.686C85.3977 342.215 103.986 352.003 123.452 357.776C123.959 357.927 124.479 358.005 125 358.005C125.521 358.005 126.037 357.927 126.548 357.776C146.009 351.998 164.602 342.215 181.816 328.686C224.51 295.129 250 241.247 250 184.543V80.8166C250 77.8158 247.57 75.3814 244.565 75.3814ZM217.116 184.543C217.116 231.236 196.322 275.457 161.497 302.83C149.928 311.924 137.679 318.903 125 323.635C112.326 318.907 100.081 311.928 88.508 302.83C53.6784 275.462 32.8885 231.245 32.8885 184.543V106.76C60.6937 103.658 86.5441 95.8069 108.773 83.6028C115.012 80.1772 120.428 76.7197 125.05 73.4402C129.695 76.7197 135.13 80.1818 141.396 83.6119C163.643 95.7932 189.439 103.635 217.121 106.746V184.543H217.116Z"
          fill="url(#paint0_linear_11_29)"
        />
        <path
          d="M93 194.625L117 219L173 154"
          stroke="#0C1C43"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M284.938 2.4375C284.938 1.09131 283.846 0 282.5 0C281.154 0 280.062 1.09131 280.062 2.4375C280.062 12.5783 277.824 19.3236 273.574 23.574C269.324 27.8243 262.578 30.0625 252.438 30.0625C251.091 30.0625 250 31.1538 250 32.5C250 33.8462 251.091 34.9375 252.438 34.9375C262.578 34.9375 269.324 37.1757 273.574 41.426C277.824 45.6764 280.062 52.4217 280.062 62.5625C280.062 63.9087 281.154 65 282.5 65C283.846 65 284.938 63.9087 284.938 62.5625C284.938 52.4217 287.176 45.6764 291.426 41.426C295.676 37.1757 302.422 34.9375 312.562 34.9375C313.909 34.9375 315 33.8462 315 32.5C315 31.1538 313.909 30.0625 312.562 30.0625C302.422 30.0625 295.676 27.8243 291.426 23.574C287.176 19.3236 284.938 12.5783 284.938 2.4375Z"
        fill="#0D2B57"
      />
      <defs>
        <linearGradient
          id="paint0_linear_11_29"
          x1="125"
          y1="31.9988"
          x2="125"
          y2="358.005"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BEF3D1" />
          <stop offset="1" stopColor="#BEF3D1" stopOpacity="0.2" />
        </linearGradient>
        <clipPath id="clip0_11_29">
          <rect width="250" height="326" fill="white" transform="translate(0 32)" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgShiftProtection);
export default ForwardRef;
